import React from 'react';

export interface PageLoadedContextProps {
  pagesLoaded: string[];
  setPageLoaded: (page: string) => void;
}

const PageLoadedContext = React.createContext<PageLoadedContextProps>(null);

export default PageLoadedContext;
